import React from "react";
const DropdownArrowIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.3535 6.35352L8.35352 10.3535L4.35352 6.35352L5.06052 5.64652L8.35352 8.93952L11.6465 5.64652L12.3535 6.35352Z",
      fill: "currentColor"
    }
  )
);
var DropdownArrowIcon_default = DropdownArrowIcon;
export {
  DropdownArrowIcon_default as default
};
//# sourceMappingURL=DropdownArrowIcon.js.map
